import { Component, OnInit, Output, Input } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { ReservationService } from '../../../trip-reservations/reservations.service';
import {IChangesResponse, IResultResponse} from '../../../../core/interfaces/response.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-dispatch-massive-change-status',
  templateUrl: './massive-change-status.component.html',
  styleUrls: ['./massive-change-status.component.scss']
})
export class MassiveChangeStatusComponent implements OnInit {

  private tripstatusId = 0;
  private statusList: any;
  private cancelReason: any;
  private tripcancelreasonId: number;
  private hiddenCancelReason = false;
  private errorMsg = false;
  private loading = true;
  private disabledButton = true;
  private msg = '';
  private statusId = 0;
  private statusMsg = '';

  @Output() closeReservEmit: EventEmitter < any >= new EventEmitter < any > ();
  @Output() transactionResponse: EventEmitter < any >= new EventEmitter < any > ();
  @Input() trips: any;
  @Input() status: string;
  @Input() companyId: number;
  @Input() isCompanyOndemand = false;
  @Input() showActive = true;
  @Input() onlyCancel = false;


  constructor(private service: ReservationService, private sweetAlertHelper: SweetAlertHelper) {
    this.service.getTripStatus().subscribe(
      dataStatus => {
        this.statusList = dataStatus;
      }
    );

    this.service.getCancelReason().subscribe(
      data => {
        this.cancelReason = data;
      }
    );
  }

  /**
   * @name ngOnInit
   * @description
   */
  ngOnInit() {

    if (this.status === 'Open') {
      this.statusId = 1;
    }

    if (this.status === 'Active') {
      this.statusId = 2;
    }


    if (this.status === 'Accepted') {
      this.statusId = 3;
    }

    if (this.status === 'Pickup') {
      this.statusId = 5;
    }

    if (this.status === 'NoShow') {
      this.statusId = 6;
    }

    if (this.status === 'Cancelled') {
      this.statusId = 7;
    }

    if (this.status === 'Closed') {
      this.statusId = 8;
    }

    if (this.status === 'Rejected') {
      this.statusId = 9;
    }

    if (this.status === 'Completed') {
      this.statusId = 10;
    }

    if (this.status === 'Verify') {
      this.statusId = 11;
    }

    if (this.status === 'Billed') {
      this.statusId = 12;
    }

  }


  /**
   * @name msgFront
   * @description
   * @param status
   */
  private msgFront(status) {

    if (status === 1) {
      this.statusMsg = 'Open';
    }

    if (status === 2 || status === 14) {
      this.statusMsg = 'Active';
    }

    if (status === 3) {
      this.statusMsg = 'Accepted';
    }

    if (status === 5) {
      this.statusMsg = 'Pickup';
    }

    if (status === 6) {
      this.statusMsg = 'NoShow';
    }

    if (status === 7) {
      this.statusMsg = 'Cancelled';
    }

    if (status === 8) {
      this.statusMsg = 'Closed';
    }

    if (status === 9) {
      this.statusMsg = 'Reject';
    }

    if (status === 10) {
      this.statusMsg = 'Completed';
    }

    if (status === 11) {
      this.statusMsg = 'Verify';
    }

    if (status === 12) {
      this.statusMsg = 'Billed';
    }

  }

  /**
   * @name onCloseReservModalTrip
   * @description
   */
  onCloseReservModalTrip() {
    this.closeReservEmit.emit(true);
  }

  /**
   * @name onSelectStatus
   * @description
   * @param event
   */
  onSelectStatus(event) {
    if (event === 7) {
      this.hiddenCancelReason = true;
    } else {
      this.hiddenCancelReason = false;
      this.errorMsg = false;
      this.tripcancelreasonId = null;
    }
  }

  /**
   * @name onSelectCancelReason
   * @description
   * @param event
   */
  onSelectCancelReason(event) {
    if (event > 0) {
      this.errorMsg = false;
    } else {
      this.errorMsg = true;
    }
  }

  /**
   * @name onSaveStatusTrip
   * @description
   */
  onSaveStatusTrip() {

    this.sweetAlertHelper.createCustomAlert({
      title: 'Are you sure?',
      text: 'Do you want to continue',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        if ((this.hiddenCancelReason) && (this.tripcancelreasonId == null)) {
          this.errorMsg = true;
          return false;
        }
        const data = {
          dataid: this.tripstatusId,
          tripstochange: this.trips,
          dataauxid: this.tripcancelreasonId
        };
        this.disabledButton = true;
        this.loading = false;
        this.service
          .changeStatusTrips(data)
          .subscribe(
            (success: IChangesResponse) => {
              this.responseUpdate(success);
            },
            error => {
            }
          );
      }
    });
  }


  /**
   * @name
   * @description
   * @param status
   */
  changeStatusButtom(status) {

    this.tripstatusId = status;
    this.onSelectStatus(status);
    this.disabledButton = false;
    this.msgFront(status);
    this.msg = this.trips.length + ' Trips will be update to ' + this.statusMsg + ' status';

  }

  /**
   * @name
   * @description
   * @param data
   */
  responseUpdate(data: IChangesResponse) {
    if (data && data.tripschangeresponse.length) {
      const html: string[] = [];
      data.tripschangeresponse.forEach(
        (item: IResultResponse) => {
          if (!item.changedsuccessfull) {
            html.push(`<p><span style="color: black">Error: </span><span style="color: red">${item.error}</span></p>`);
          }
        }
      );
      if (html.length) {
        this.sweetAlertHelper.createCustomAlert({
          title: 'Error',
          html: `<div style="text-align: center">${html}</div>`,
          type: 'error',
        });
      }
    }
    this.transactionResponse.emit(data.tripschangeresponse);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dispatch/components/massive-change-status/massive-change-status.component.ts